import { render } from "./BaseButton.vue?vue&type=template&id=e6210c82"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
script.render = render

export default script